import Vue from 'vue'
import axios from 'axios'
import { ls } from 'vue-lsp'
import { message, Modal, notification  } from 'ant-design-vue' /// es/notification
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {useRouter} from 'vue-router'
import {useStore} from 'vuex'

// 创建 axios 实例
const service = axios.create({
	//baseURL: '/api', // api base_url
	//baseURL: process.env.VUE_APP_BASE_API,
	baseURL:GetBaseUrl(),
	timeout: 60000 // 请求超时时间
})

const err = (error) => {
	if (error.response) {
		const data = error.response.data
		const token = ls.get(ACCESS_TOKEN)

		if (error.response.status === 403) {
			console.log('服务器403啦，要重新登录！')
			notification.error({
				message: 'Forbidden',
				description: data.message
			})
		}
		if (error.response.status === 500) {
			if (data.message.length > 0) {
				message.error(data.message)
			}
		}
		if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
			// notification.error({
			// 	message: 'Unauthorized',
			// 	description: 'Authorization verification failed'
			// })
			window.location.replace('/#/login')
			message.error('已经登录超时请重新登录')
		}
	}
	console.log(error)
	return Promise().reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
	//config.headers["Access-Control-Allow-Origin"]= "*";
	//config.headers["Access-Control-Allow-Headers"]="Content-Type,Content-Length, Authorization, Accept,X-Requested-With,x-access-token";
	//config.headers["Access-Control-Allow-Methods"]= "PUT,POST,GET,DELETE,OPTIONS";

	const token = ls.get(ACCESS_TOKEN)
	if (token) {
		config.headers['Authorization'] = 'Bearer ' + token
	}
	return config
}, err)

/**
 * response interceptor
 * 所有请求统一返回
 */
service.interceptors.response.use((response) => {
	//console.log(response)
	//const store = useStore();
	//const router = useRouter();
	if (response.request.responseType === 'blob') {
		return response
	}
	//const store = useStore();
	const code = response.data.statusCode
	if (code === 5001) {
		message.error("授权失败,请重新登录；"+response.data.errors)
		return response.data
	} else {
		return response.data
	}
}, err)

const installer = {
	vm: {},
	install(Vue) {
		Vue.use(VueAxios, service)
	}
}

export {
	installer as VueAxios,
	service as axios
	
}
export function GetBaseUrl() {
	//var baseurl=uni.getStorageSync(DEFAULT_BASEURL);
	//console.log(baseurl)
	var baseurl=""
	//if(baseurl)
		//baseurl='http://localhost:5566'
		//baseurl='https://app.rotaryliftasia.com:8007/api'
		baseurl='https://app.rotaryliftasia.com'
		//baseurl='http://58.221.9.67:10402'
		if (window.location.pathname.includes('/demo')){
			baseurl='https://app.rotaryliftasia.com/demo'
		}
		//baseurl='https://app.rotaryliftasia.com/demo'
		if(window)
		{
			if(window.location.host.indexOf('10.25.0.12')>-1)
				baseurl='http://10.25.0.12:8009'
			if(window.location.host.indexOf('10.198.194.69')>-1)
				baseurl='http://10.198.194.69:8009'
			if(window.location.host.indexOf('10.25.0.48')>-1)
				baseurl='http://10.25.0.48:10401'
		}
		//baseurl='http://10.25.0.48:10401'
	return baseurl;
}

//export function GetBaseUrl()